<template>
  <div class="applyPage" id="tinyScreenApply">
    <Header></Header>
    <!-- contain -->
    <div class="conntentBox">
      <div class="container">
        <h6 class="title">{{title}}</h6>
        <h5 class="subTitle mt47 mb25">基本信息</h5>
        <el-form :model="AddJobApplyInfoVo" :rules="rules" ref="AddJobApplyInfoVo">
          <el-form-item label="姓名" prop="realname" class="relative">
            <!-- <span class="absolute">有效证件的全名</span> -->
            <el-input v-if="isCommit" v-focus @click.native="changeFoucus" ref="inputBox" v-model="AddJobApplyInfoVo.realname" placeholder="请输入"></el-input>
            <p v-else class="textCommit">{{AddJobApplyInfoVo.realname}}</p>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-row v-if="isCommit">
              <el-col :span="4">
                <country-code-selector :countryCode.sync="countryCode"></country-code-selector>
               <!--  <el-select v-model="AddJobApplyInfoVo.name" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select> -->
              </el-col>
              <el-col :span="20">
                <el-input @click.native="changeMobileFoucus" v-focus ref="inputMobileBox" v-model.number="AddJobApplyInfoVo.mobile" placeholder="请输入"></el-input>
              </el-col>
            </el-row> 
            <p v-else class="textCommit">
              <span class="mr15">{{countryCode}}</span>
              <span>{{AddJobApplyInfoVo.mobile}}</span>
            </p>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="email">
            <el-input @click.native="changeEmailFoucus" v-focus ref="inputEmailBox" v-if="isCommit" v-model="AddJobApplyInfoVo.email" placeholder="请输入"></el-input>
            <p v-else class="textCommit">{{AddJobApplyInfoVo.email}}</p>
          </el-form-item>
          <el-form-item label="你是从何得知我们的招聘信息？" prop="sourceInfo">
            <el-select v-if="isCommit" @change="handleShow" class="w100" v-model="AddJobApplyInfoVo.sourceInfo" placeholder="请选择">
              <el-option
                v-for="item in infoOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <p v-else class="textCommit">{{AddJobApplyInfoVo.sourceInfo == 1?'佳期投资官网':AddJobApplyInfoVo.sourceInfo == 2?'佳期投资公众号':AddJobApplyInfoVo.sourceInfo == 3?'佳期投资LinkedIn':AddJobApplyInfoVo.sourceInfo == 4?'佳期员工内推':AddJobApplyInfoVo.sourceInfo == 5?'学校就业网站':AddJobApplyInfoVo.sourceInfo == 6?'校园招聘活动（招聘会、宣讲会等）':AddJobApplyInfoVo.sourceInfo == 7?'老师同学朋友分享':AddJobApplyInfoVo.sourceInfo == 8?'猎头':AddJobApplyInfoVo.sourceInfo == 9?'知乎':AddJobApplyInfoVo.sourceInfo == 10?'其他公众号':AddJobApplyInfoVo.sourceInfo == 11?'第三方招聘网站':'其他'}}</p>
          </el-form-item>
           <el-form-item label="备注" v-if="show" v-focus prop="sourceDetail">
            <el-input  @click.native="changeSourceDetailFoucus" ref="inputSourceDetailBox" v-if="isCommit" v-model="AddJobApplyInfoVo.sourceDetail" :placeholder="placeholder"></el-input>
            <p v-else class="textCommit">{{AddJobApplyInfoVo.sourceDetail}}</p>
          </el-form-item>
        </el-form>
        <h5 class="subTitle mt47 mb30">简历上传</h5>
        <div>
          <el-upload v-if="isCommit"
            class="upload-demo"
            drag
            :file-list="resumeList"
            :limit='1'
            :before-upload="beforeResumeUpload"
            :on-remove="handleChangeResume"
            :on-success="handleResumeSuccess"
            action="https://www.jqinvestments.com/interface/job/uploadFile.do"
            multiple>
            <div class="el-upload__text">请上传你的简历</div>
            <span class="uploadBtn">选择文件</span>
            <div class="uploadTip">请将文件控制在5MB以内，支持格式：PDF、DOC、DOCX、JPG、JPEG、PNG、XLS、XLSX。如有两个及以上文件，请压缩成ZIP格式再上传</div>
          </el-upload>
          <div v-else class="el-upload">
            <img class="uploadedPic" src="../../assets/picture/occupation/resume.png">
            <p class="fileName" @click="goPage(AddJobApplyInfoVo.resumePath)">{{resumeName}}</p>
          </div>
        </div>
        <h5 class="subTitle mt47 mb30">其他附件</h5>
        <div>
          <el-upload v-if="isCommit"
            class="upload-demo"
            drag
            :file-list="attachmentsList"
            :limit='3'
            :before-upload="beforeEnclosureUpload"
            :on-remove="handleChangeEnclosure"
            :on-success="handleEnclosureSuccess"
            action="https://www.jqinvestments.com/interface/job/uploadFile.do"
            multiple>
            <div class="el-upload__text">其他附件上传</div>
            <span class="uploadBtn">选择文件</span>
            <div class="uploadTip">若你有其他附件（比如cover letter、成绩单、获奖证书等）需要上传，请将文件控制在5MB以内，支持格式：PDF、DOC、DOCX、JPG、JPEG、PNG、XLS、XLSX。如有两个及以上文件，请压缩成ZIP格式再上传</div>
          </el-upload>
          <div v-else class="el-upload">
            <img class="uploadedPic" src="../../assets/picture/occupation/enclosure.png">
            <p class="fileName" v-for="(item,index) in attachmentsList" :key="index" @click="goPage(item.url)">{{item.name}}</p>
          </div>
        </div>
        <div v-if="isCommit">
          <div class="mt47 fr pcShow">
            <el-checkbox v-model="checked">
              我已阅读并同意
              <span @click="centerDialogVisible = true" class="txtRed mr15">隐私政策</span>
            </el-checkbox>
            <span @click="handleSubmit('AddJobApplyInfoVo')" class="submitBtn">预览并提交</span>
          </div>
          <div class="mt47 fr phoneShow footerBtn">
            <el-checkbox v-model="checked">
              我已阅读并同意
              <span @click="goPrivacyPolicyPage" class="txtRed mr15">隐私政策</span>
            </el-checkbox>
            <span @click="handleSubmit('AddJobApplyInfoVo')" class="phoneSubmitBtn">预览并提交</span>
          </div> 
        </div>
        <div v-else>
          <div class="mt47 fr pcShow">
            <span @click="isCommit = true" class="submitBtn mr15">返回上一层</span>
            <span @click="addJobApply" class="submitBtn">确认并提交</span>
          </div>
          <div class="mt47 fr phoneShow footerBtn">
            <span @click="isCommit = true" class="phoneSubmitBtn">返回上一层</span>
            <span @click="addJobApply" class="phoneSubmitBtn">确定并提交</span>
          </div> 
        </div>
      </div>
    </div>
    <!-- footer -->
    <Footer></Footer>
    <!-- 隐私政策 --> 
    <el-dialog class="cognizanceBox"
      :title="$t('privacyPolicy.agreement')"
      :visible.sync="centerDialogVisible"
      width="50%" :show-close="false"
      center>
      <p class="downTxt t2em" v-html="content"></p>
      <span slot="footer" class="dialog-footer">
        <el-button class="admitBtn" type="primary" @click="centerDialogVisible = false">{{$t('privacyPolicy.determine')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Header from '../common/header';
import Footer from '../common/footer';
import countryCodeSelector from 'vue-country-code-selector';
export default {
  data() {
    return {
      isCommit:true,
      centerDialogVisible:false,
      isShowSearch:false,
      title:'',
      content:'',
      placeholder:'',
      checked:false,
      show:false,
      countryCode:86,
      resumeList:[],
      attachmentsList:[],//附件列表
      resumeName:'',//简历名称
      AddJobApplyInfoVo:{
        attachments:'',
        email:'',
        jobId:'',
        mobile:'',
        realname:'',
        resumePath:'',
        sourceInfo:'',
        sourceDetail:'',
      },
      rules: {
        realname: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern:/^[0-9]*$/, message: '请正确输入手机号码', trigger: 'blur' },
        ],
        email:
            [
          {required: true, message: '请输入电子邮箱', trigger: 'blur'},
          { pattern:/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, message: '请正确输入邮箱', trigger: 'blur' },
        ],
        sourceInfo: [
          { required: true, message: '请选择招聘信息来源', trigger: 'change' }
        ],
      },
      infoOptions:[
        {
          value:1,
          label:'佳期投资官网'
        },
        {
          value:2,
          label:'佳期投资公众号'
        },
        {
          value:3,
          label:'佳期投资LinkedIn'
        },
        {
          value:4,
          label:'佳期员工内推'
        },
        {
          value:5,
          label:'学校就业网站'
        },
        {
          value:6,
          label:'校园招聘活动（招聘会、宣讲会等）'
        },
        {
          value:7,
          label:'老师同学朋友分享'
        },
        {
          value:8,
          label:'猎头'
        },
        {
          value:9,
          label:'知乎'
        },
        {
          value:10,
          label:'其他公众号'
        },
        {
          value:11,
          label:'第三方招聘网站'
        },
        {
          value:12,
          label:'其他'
        },
      ]
    };
  },
  components: { Header,Footer,countryCodeSelector },
  mounted(){
    this.title = this.$route.query.title?this.$route.query.title:'';
    this.AddJobApplyInfoVo.jobId = this.$route.query.jodId?this.$route.query.jodId:'';
    this.getHegeTouzi();
  },
  methods: {
    showSearch(){
      this.isShowSearch = !this.isShowSearch;
    },
    changeFoucus() {
      this.$nextTick(function () {
          this.$refs.inputBox.$el.querySelector('input').focus();
      });
    },
    changeMobileFoucus() {
      this.$nextTick(function () {
          this.$refs.inputMobileBox.$el.querySelector('input').focus();
      });
    },
    changeEmailFoucus() {
      this.$nextTick(function () {
          this.$refs.inputEmailBox.$el.querySelector('input').focus();
      });
    },
    changeSourceDetailFoucus() {
      this.$nextTick(function () {
          this.$refs.inputSourceDetailBox.$el.querySelector('input').focus();
      });
    },
    // 获取私隐政策
    async getHegeTouzi() {
        const { data: res } = await this.$http.get("/article/getPrivacyPolicy.do");
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
        this.content = res.data.content;
    },
    // 判断是否显示备注来源
    handleShow(){
      if(this.AddJobApplyInfoVo.sourceInfo == 4 || this.AddJobApplyInfoVo.sourceInfo == 10 || this.AddJobApplyInfoVo.sourceInfo == 11 || this.AddJobApplyInfoVo.sourceInfo == 12){
        this.show = true;
        if(this.AddJobApplyInfoVo.sourceInfo == 4){
          this.placeholder = '请备注推荐人';
        }else if(this.AddJobApplyInfoVo.sourceInfo == 10){
          this.placeholder = '请输入该公众号名称';
        }else if(this.AddJobApplyInfoVo.sourceInfo == 11){
          this.placeholder = '请输入该网站名称';
        }else if(this.AddJobApplyInfoVo.sourceInfo == 12){
          this.placeholder = '请输入具体渠道';
        }
      }else{
        this.show = false;
        this.AddJobApplyInfoVo.sourceDetail = '';
      }
    },
    // 跳转文件
    goPage(file){
      window.open(file, '_blank');
    },
    // 提交简历成功
    handleResumeSuccess(response, file, fileList) {
      this.resumeName = file.name;
      this.AddJobApplyInfoVo.resumePath = response.data.attachments[0];
      let item = {
        name:file.name,
        url:response.data.attachments[0]
      }
      this.resumeList.push(item);
    },
    // 删除简历
    handleChangeResume(file, fileList) {
      this.resumeList = [];
      this.resumeName = '';
      this.AddJobApplyInfoVo.resumePath = '';
    },
    // 限制上传
    beforeResumeUpload(file) {
      console.log(file.type,'type');
      const isFile = file.type === 'image/jpeg' || 'application/x-zip-compressed' || 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || 'application/vnd.ms-excel';
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isFile) {
        this.$message.error('上传简历文件只能是PDF、DOC、DOCX、JPG、JPEG、PNG、XLS、XLSX格式!');
      }
      if (!isLt5M) {
        this.$message.error('上传简历文件大小不能超过 5MB!');
      }
      return isFile && isLt5M;
    },
    // 提交附件成功
    handleEnclosureSuccess(response, file, fileList) {
      let item = {
        name:file.name,
        url:response.data.attachments[0]
      }
      this.attachmentsList.push(item);
    },
    // 删除附件
    handleChangeEnclosure(file, fileList) {
      let url = file.url;
      this.attachmentsList.map((e,i)=>{
        if(e.url == url){
          this.attachmentsList.splice(i,1);
        }
      })
    },
    // 限制上传
    beforeEnclosureUpload(file) {
      console.log(file.type,'file.type');
      const isFile = file.type === 'image/jpeg' || 'application/x-zip-compressed' || 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || 'application/vnd.ms-excel';
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isFile) {
        this.$message.error('上传附件文件只能是PDF、DOC、DOCX、JPG、JPEG、PNG、XLS、XLSX格式!');
      }
      if (!isLt5M) {
        this.$message.error('上传附件文件大小不能超过 5MB!');
      }
      return isFile && isLt5M;
    },
    // 跳转隐私政策
    goPrivacyPolicyPage(){
      this.$router.push({  
          path: '/privacyPolicy',       
      })
    },
    // 提交并预览
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.checked){
            this.isCommit = false;
          }else{
             this.$message({
              message: '请勾选同意并阅读隐私条款',
              type: 'warning'
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 职位新增接口
    async addJobApply() {
      let list = [];
      this.attachmentsList.map(e=>{
        list.push(e.url);
      })
      this.AddJobApplyInfoVo.attachments = list.join(','); 
      const { data: res } = await this.$http.post("/job/addJobApply.do",this.AddJobApplyInfoVo);
      if (res.code !== 200) return this.$message.error(res.message);
      this.$message({
        message: res.message,
        type: 'success'
      });
      // this.$router.go(-1);
      this.$router.push({  
          path: '/socialDetail',
          query:{id:this.AddJobApplyInfoVo.jobId}
      })
    },
  }
};
</script>

<style lang="less" scoped>
  .applyPage{
    /deep/.checkbox, .form-control, /deep/ .radio, /deep/ input[type=file], /deep/output{
      display: none !important;
    }
    /deep/ .intl-tel-input-container{
      border:1px solid #DCDFE6;
      height: 50px;
      line-height: 50px;
      font-size: 14px;
      border-right: none;
    }
    /deep/ .el-form-item__content{
      display: ruby !important;
    }
    /deep/ .flag-list-box{
      background: #fff;
    }
    /deep/ .flag{
      display: none;
    }
    /deep/ .area-codeNum{
      padding:0 10px;
    }
    .absolute{
      position: absolute;
      left: 9%;
      top: -49px;
      color: #9A9A9A;
      font-size: 20px;
    }
    /*隐私政策*/
  .cognizanceBox{
    z-index:999;
    padding:52px 60px 72px 60px;
     /deep/ .el-dialog{
        background: #F2F2F2 !important;
      }
    /deep/ .el-dialog__title{
      font-size: 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #900211;
      line-height: 42px;
      letter-spacing: 2px;
    }
    /deep/ .el-dialog__body{
      padding: 0 20px 43px 60px;
      height: 520px;
      overflow-y: scroll;
      width: 97%;
    }
     /deep/ .el-dialog__body::-webkit-scrollbar {
        width: 4px;

      }
      /deep/ .el-dialog__body::-webkit-scrollbar-track {
        background-color: #D8D8D8;
        -webkit-border-radius: 2em;
        -moz-border-radius: 2em;
        border-radius: 2em;
      }
      /deep/ .el-dialog__body::-webkit-scrollbar-thumb {
        background-color: #900211;
        -webkit-border-radius: 2em;
        -moz-border-radius: 2em;
        border-radius: 2em;
      }
    /deep/ .el-dialog__header{
      padding:52px 0 21px 0;
    }
    /deep/ .el-dialog__footer{
      padding:43px 0 78px 0;
    }

    .upTxt{
      font-size: 14px;
      font-weight: bold;
      color:#333333;
      line-height: 30px;
    }
    .downTxt{
      font-size: 12px;
      color: #808080;
      line-height: 30px;
      letter-spacing: 1px;
    }
    .finalTxt{
      font-size: 12px;
      color: #9A9A9A;
      line-height: 30px;
      letter-spacing: 1px;
      text-align: right;
    }
    .admitBtn{
      width: 130px;
      height: 44px;
      background: #900211;
      text-align: center;
      color: #fff;
      font-size: 14px;
      border:none;
      border-radius: 0;     
      letter-spacing: 5px;
    }
    .cancelBtn{
      width: 130px;
      height: 44px;
      background: #9A9A9A;
      text-align: center;
      color: #fff;
      font-size: 14px;
      border:none;
      border-radius: 0;
    }
  }
    .conntentBox{
      padding-bottom: 120px;
      .container{
        width: 850px;
      }
      .title{    
        font-weight: 600;
        color: #353535;
        font-size: 35px;       
        letter-spacing: 2px;
      }
      .subTitle{
        color: #900211;
        font-size: 26px;       
        font-weight: 400;
        color: #900211;
        line-height: 37px;
      }
      /deep/ .el-form-item__label{
        display: contents;
      }
      .textCommit{   
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9A9A9A;
        line-height: 20px;
      }
      .el-row{
        display: flex;
      }
      .w100{
        /deep/ .el-select{
          width: 100%;
        }
      }
      /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
        background: #900211;
        border-color: #900211;
      }
      /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
        color:#333;
      }
      /deep/ .el-form-item__label{     
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 28px;
        letter-spacing: 1px;
      }
      /deep/ .el-form-item__content{
        margin-top: 15px;
        margin-bottom: 15px;
      }
      /deep/ .el-input__inner{
        height: 50px;
      }
      .submitBtn{
        color:#fff;
        width: 224px;
        height: 44px;
        background: #900211;       
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        line-height: 44px;
        letter-spacing: 10px;
        display: inline-block;
        text-align: center;
        cursor: pointer;
      }
      .phoneSubmitBtn{
        color:#fff;
        width: 224px;
        height: 44px;
        background: #900211;       
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        line-height: 44px;
        letter-spacing: 10px;
        display: block;
        text-align: center;
        cursor: pointer;
      }
      /deep/ .el-checkbox__inner:hover{
        border-color:#900211;
      }
      /deep/ .el-checkbox__inner::after{
        border: 1px solid #900211;
      }
      /deep/ .el-upload{
        width: 100%;
        background: #F0F0F2;
        padding-top: 55px;
        padding-bottom: 60px;
        .uploadedPic{
          width: 100px;
          display: block;
          margin: 0 auto;
        }
        .fileName{
          margin-top: 22px;
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 28px;
          text-align: center;
        }
         .el-upload{
          width: 100%;
          background: #F0F0F2;
        }
        .el-upload-dragger{
          border: none;
          width: 100%;
          background: #F0F0F2;
          height: auto !important;
        }
        .el-upload__text{       
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 37px;
          text-align: center;
        }
        .uploadBtn{
          margin-top:55px;
          width: 224px;
          height: 44px;
          background: #900211; 
          color:#fff;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          letter-spacing: 10px;
          text-align: center;
          display: block;
          line-height: 44px;
          margin:0 auto;
          margin-top: 38px;
        }
        .uploadTip{       
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #9A9A9A;
          line-height: 24px;
          letter-spacing: 1px;
          margin-top: 33px;
          padding:0 4rem;
        }
        /deep/ .el-upload__input{
          display: none !important;
          opacity:0 !important;
          height:0 !important;
          width:0 !important;
          visibility: hidden !important;
          pointer-events: none !important;
          position: absolute !important; /* 避免占用 input 元素额外的 padding，正常情况下存在 display: none!; 就可以了 */
          right: 0 !important;
        }
      }
    }
  }
</style>
